import React from 'react';
import Overlay from '../../partials/white_overlay';

const Fields = () => {
    return (
        <div style={{ position: 'relative' }}>
            <Overlay />
            <div className="p-4 hind" style={{ mixBlendMode: 'screen' }}>
                <h2 className="hind">Field Dimensions</h2>
                <p>Regular size fields are Length 35-40 yards, Width 25-30 yards.  U8 and Under will play on smaller fields with Length 25-30, Width 15-20.</p>
                <p>Goals are 4 feet high by 8 feet wide. The Goal Box is 12 feet wide by 8 feet deep, and center circles are 10 yards in diameter (5 yard radius).</p>
            </div>
        </div>
    );
}

export default Fields;



// WEBPACK FOOTER //
// ./src/components/rules/partials/fields.js